import React, { useState } from "react";
import "./css/ProductCard.css"; // Import the CSS file for styling
import axios from "axios";
import Error from "./NotAuthorizedError";
import SuccessMessage from "../Auth/SuccessMessage";
import { ReactComponent as TrashIcon } from "../../icons/trash.svg";
import { useNavigate, useLocation } from "react-router-dom";

const ProductCard = ({
  product,
  showButton = false,
  quantity,
  showQuantity = false,
  updateBasketSum,
}) => {
  const [currentQuantity, setCurrentQuantity] = useState(quantity); // Локальное состояние для количества товара
  const [totalSum, setTotalSum] = useState(product.product_price * quantity); // Сумма товара, вычисляется по умолчанию
  const [showSuccess, setShowSuccess] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const location = useLocation();
  const navigate = useNavigate()
  const handleShowToast = () => setShowToast(true);
  const handleCloseToast = () => setShowToast(false);

  const updateQuantityOnServer = async (action, from="") => {
    const token = localStorage.getItem("access_token");
    const data = {
      product: product.id,
      action: action,
    };

    try {
      await axios.post("https://monkeprogrammer01.pythonanywhere.com/products/add/", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (from!=="increase" && action!=="decrease"){
        setShowSuccess(true);
        setTimeout(() => {
        setShowSuccess(false);
      }, 1500);
      }

    } catch (error) {
      console.log("Error during quantity update:", error);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  const handleSubmit = (e) => {
    e.stopPropagation()
    const newPrice = product.product_price;
    setCurrentQuantity((prev) => prev + 1);
 
    setTotalSum((prev) => prev + product.product_price);
    updateQuantityOnServer("add");
    


  };

  const handleIncrease = (e) => {
    e.stopPropagation()
    const newPrice = product.product_price;
    setCurrentQuantity((prev) => prev + 1);
    setTotalSum((prev) => prev + product.product_price);
    updateBasketSum(newPrice);
    updateQuantityOnServer("add", "increase");
  };



  const handleDecrease = (e) => {
    e.stopPropagation()
    if (currentQuantity > 1) {
      const newPrice = -product.product_price;
      setCurrentQuantity((prev) => prev - 1);
      setTotalSum((prev) => prev + product.product_price);
      updateBasketSum(newPrice);
      updateQuantityOnServer("decrease"); // Отправка запроса на сервер для уменьшения количества
    }
  };

  const removeFromBasket = async (e) => {
    e.stopPropagation();

    e.preventDefault(); // Предотвращаем переход по ссылке
  
    const token = localStorage.getItem("access_token");
    const data = {
      product: product.id,
      action: "remove",
    };
  
    try {
      await axios.post("https://monkeprogrammer01.pythonanywhere.com/products/add/", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
  
      setCurrentQuantity(0);
      setTotalSum(0);
      updateBasketSum(-product.product_price * currentQuantity);   
      window.location.reload();

    } catch (error) {
      console.error("Ошибка при удалении товара из корзины:", error);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };
  

  const handleClean = () => {};

  return (
    <>
<div
  className="product-card"
  onClick={ () => navigate(`/product/${product.id}`)}>
        <img
          src={`https://monkeprogrammer01.pythonanywhere.com${product.first_image}`}
          className="product-card__image"
          alt={product.product_name}
        />
        <div>
          <h3 className="product-card__title">{product.product_name}</h3>
          <p className="product-card__price">{product.product_price} KZT</p>

          {showQuantity && (
            <div className="product-card__quantity-controls">
              <button
                className="product-card__quantity-button"
                onClick={handleDecrease}
              >
                -
              </button>
              <span className="product-card__quantity">{currentQuantity}</span>
              <button
                className="product-card__quantity-button"
                onClick={handleIncrease}
              >
                +
              </button>
              <a href="#" onClick={removeFromBasket}>
                <TrashIcon />
              </a>

            </div>
          )}
        </div>

        {showButton && (
          <button className="product-card__button" onClick={handleSubmit}>
            Добавить в корзину
          </button>
        )}
      </div>

      <Error show={showToast} onClose={handleCloseToast} />
      {showSuccess && (
        <SuccessMessage
          onClose={() => setShowSuccess(false)}
          message={"Добавлено в корзину!"}
        />
      )}
    </>
  );
};

export default ProductCard;
